import { Members } from '@/pages/setup-fund/utils/type';

export const OwnerTypes = {
  USER: 'User',
  ENTITY: 'Entity',
} as const;

export type OwnerType = (typeof OwnerTypes)[keyof typeof OwnerTypes];

export interface InvestmentOwner {
  ownerId?: string;
  ownerType?: OwnerType;
}

export const TransactionDirection = {
  INCOMING: 'Incoming',
  OUTGOING: 'Outgoing',
} as const;

export type TransactionDirectionType =
  (typeof TransactionDirection)[keyof typeof TransactionDirection];

export const TransactionTypes = {
  SUBSCRIPTION: 'Subscription',
  CAPITAL_CONTRIBUTION: 'CapitalContribution',
  LOAN: 'Loan',
  INTEREST: 'Interest',
  DIVIDEND: 'Dividend',
  CAPITAL_GAIN: 'CapitalGain',
  ROYALTY: 'Royalty',
  INCOME: 'Income',
  GIFT: 'Gift',
  TRANSFER: 'Transfer',
  SWAP: 'Swap',
  ONCHAIN_ACTIVITY: 'OnchainActivity',
} as const;

export type TransactionType = (typeof TransactionTypes)[keyof typeof TransactionTypes];

export const InvestmentAvailabilityStatus = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  PRE_LAUNCH: 'PreLaunch',
  PRIVATE: 'Private',
} as const;

export type InvestmentAvailabilityStatusType =
  (typeof InvestmentAvailabilityStatus)[keyof typeof InvestmentAvailabilityStatus];

export const FundDraftStatus = {
  NONE: 'None',
  CREATED: 'Created',
  PENDING_REVIEW: 'PendingReview',
  REJECTED: 'Rejected',
} as const;

export type FundDraftStatusType = (typeof FundDraftStatus)[keyof typeof FundDraftStatus];

export interface FundMemberMutationParams {
  id: string;
  memberId: string;
}
export interface EditFundMemberBody {
  title: string;
}

export type AdminDirectors = Omit<Members, 'createdAt' | 'updatedAt'>;

export interface MyFundMembership {
  fundId: string;
  fundName: string;
  userTitle: string;
  activeSince: string;
}

export const fundApprovalStatus = {
  Verified: 'Verified',
  ReVerificationPending: 'ReVerificationPending',
  AwaitingApproval: 'AwaitingApproval',
  Blocked: 'Blocked',
  Rejected: 'Rejected',
  Draft: 'Draft',
} as const;

export type FundApprovalStatus = keyof typeof fundApprovalStatus;

export interface PreviousYearsAudit {
  documentId: string;
  period: string | null;
  notes: string | null;
}
